/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-09 15:28:33
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-09 15:29:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/service/product.service.ts
 */
import _ from 'lodash';
import { useState } from 'react';
function useProductsService({ setHasModified }) {
  const _changed = () => {
    setHasModified(true);
  };

  const [products, setProducts] = useState([]);

  const C = (product) => {
    _changed();
    const arr = _.cloneDeep(products);

    arr.push(product);
    setProducts(arr);
  };

  const U = (index, product) => {
    _changed();
    const arr = _.cloneDeep(products);
    arr[index] = product;
    setProducts(arr);
  };

  const R = (index?: number) => {
    return index >= 0 ? products[index] : products;
  };

  const D = (index: number) => {
    _changed();
    const arr = _.cloneDeep(products);
    arr.splice(index, 1);
    setProducts(arr);
  };

  return {
    products,
    setProducts,
    C,
    U,
    R,
    D,
  };
}

export default useProductsService;
